import ApplyForLiquidityModal from "./ApplyForLiquidityModal";

export default ApplyForLiquidityModal;
